import { render, staticRenderFns } from "./companyOrderItemTemplateTable.vue?vue&type=template&id=126d18c7&"
import script from "./companyOrderItemTemplateTable.vue?vue&type=script&lang=ts&"
export * from "./companyOrderItemTemplateTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports